{
    "NAME": "CodeAddModify",
    "GeneralTitle": "Generale",
    "ScopeAssignmentTitleTitle": "Assegnazione dell'ambito",
    "AddUserTitle": "Aggiungi codice",
    "ModifyCodeTitle": "Modificare il codice",
    "GUID": "IDENTIFICATORE (GUID):",
    "GUIDPlaceholder": "[Generato automaticamente]",
    "Code": "Codice:",
    "CodeType": "Tipo di codice:",
    "CodeTypeHelp": "Determina il tipo di nuovo codice",
    "CodeTypeOptionOne": "Conto\/Autorizzazione",
    "CodeTypeOptionTwo": "ACD Non disponibile",
    "CodeTypePlaceholder": "Conto\/Autorizzazione",
    "Description": "Descrizione:",
    "UpdateExisting": "Aggiornare gli elementi duplicati:",
    "TelServer": "Server di telefonia",
    "Partition": "Partizione",
    "CodeAddModify_AccountAuthorisation": "Conto\/Autorizzazione",
    "CodeAddModify_ACDNotAvailable": "ACD Non disponibile",
    "CodeAddModify_ErrorMessage_Server_Error": "Errore del server",
    "CodeAddModify_ErrorMessage_Successful": "Il successo",
    "CodeAddModify_ServerErrorTitle": "Errori di convalida",
    "CodeAddModify_ValidationWarning": "Assicurarsi che tutti i campi siano compilati correttamente",
    "CodeAddModify_ButtonHelpLabel": "Aiuto?",
    "CodeAddModify_ButtonSubmitLabel": "Risparmiare",
    "CodeAddModify_ButtonCancelLabel": "Annullamento",
    "CodeAddModify_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
    "CodeAddModify_PromptConfirm": "Sì",
    "CodeAddModify_PromptCancel": "Annullamento",
    "CodeAddModify_DetailsTitle": "Dettagli utente",
    "CodeAddModify_ValidationError": "Errore di convalida",
    "Errors_Code_Required": "Questo campo è obbligatorio",
    "Errors_Code_Validation": "Formato valido richiesto: 1, 3-5",
    "Errors_CodeAddModify_Code_Length": "Il nome del codice deve essere inferiore a 100 caratteri",
    "Errors_CodeAddModify_Description_Length": "La descrizione deve essere inferiore a 100 caratteri"
}